import { useCallback } from 'react';
import { type FeatureFlag, featureEnabled } from '../constants/features';
import { useEnv } from '../context/env-context';
import { useSite, useUser } from '../context/page-context';

export function useFeatureEnabled(feature: FeatureFlag): boolean {
  return useIsFeatureEnabled()(feature);
}

/** For flags only known at render time, such as inside callbacks or loops. */
export function useIsFeatureEnabled(): (feature: FeatureFlag) => boolean {
  const { siteId } = useSite();
  const { platform } = useEnv();
  const { isSparkStaff } = useUser();

  return useCallback(
    (feature: FeatureFlag) => featureEnabled(feature, siteId, platform, !!isSparkStaff),
    [siteId, platform, isSparkStaff],
  );
}
